/**
 * FGX-465 — Collapse empty accelerated-checkout wallet slots inside
 * `shopify-accelerated-checkout-cart` shadow DOM when theme CSS hides
 * platform-incompatible wallets (Google Pay on iOS/iPadOS, Apple Pay on Android).
 *
 * Must load synchronously in <head> before {{ content_for_header }}.
 */
(function () {
  'use strict';

  var CART_HOST = 'shopify-accelerated-checkout-cart';
  var STYLE_ATTR = 'data-rea-wallet-slot-fix';
  var HOST_FLAG = '__reaWalletSlotFix';

  /**
   * Narrow platform detection for slot-collapse rules (not html.is-ios).
   * @returns {{ collapseGooglePay: boolean, collapseApplePay: boolean }}
   */
  function getSlotFixTargets() {
    var ua = navigator.userAgent;
    var maxTouch = navigator.maxTouchPoints || 0;
    var isIPadOS = /Macintosh/.test(ua) && maxTouch > 1;
    var isIOS = !isIPadOS && /iPhone|iPod/.test(ua);
    var isAndroid = /Android/.test(ua);

    return {
      collapseGooglePay: isIOS || isIPadOS,
      collapseApplePay: isAndroid,
    };
  }

  var targets = getSlotFixTargets();
  
  var slotFixCss = buildSlotFixCss(targets);

  if (targets.collapseGooglePay) {
    document.documentElement.classList.add(
      /Macintosh/.test(navigator.userAgent) && (navigator.maxTouchPoints || 0) > 1
        ? 'is-ipados'
        : 'is-ios'
    );
  }
  
  if (targets.collapseApplePay) {
    document.documentElement.classList.add('is-android');
  }

  try {
    var origAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      if (this.localName === CART_HOST) {
        var cfg = Object.assign({}, init || {}, { mode: 'open' });
        return origAttachShadow.call(this, cfg);
      }
      return origAttachShadow.call(this, init);
    };
  } catch (e) {
    return;
  }

  /**
   * @param {{ collapseGooglePay: boolean, collapseApplePay: boolean }} t
   * @returns {string}
   */
  function buildSlotFixCss(t) {
    var selectors = [];

    if (t.collapseGooglePay) {
      selectors.push(
        'shopify-google-pay-button',
        '[data-brand="googlePay"]',
        'slot[name="button-GooglePay"]',
        '.wallet-cart-grid > [data-brand="googlePay"]',
        '.wallet-cart-grid > *:has(shopify-google-pay-button)',
        '.wallet-cart-grid > *:has([data-brand="googlePay"])',
        '.accelerated-checkout-button-container > *:has(shopify-google-pay-button)',
        '.accelerated-checkout-button-container > *:has([data-brand="googlePay"])',
        '.wallet-cart-button-container:has(shopify-google-pay-button)',
        '.wallet-cart-button-container:has([data-brand="googlePay"])',
        '.wallet-cart-button-container:has(slot[name="button-GooglePay"])'
      );
    }

    if (t.collapseApplePay) {
      selectors.push(
        'shopify-apple-pay-button',
        '[data-brand="applePay"]',
        'slot[name="button-ApplePay"]',
        '.wallet-cart-grid > [data-brand="applePay"]',
        '.wallet-cart-grid > *:has(shopify-apple-pay-button)',
        '.wallet-cart-grid > *:has([data-brand="applePay"])',
        '.accelerated-checkout-button-container > *:has(shopify-apple-pay-button)',
        '.accelerated-checkout-button-container > *:has([data-brand="applePay"])',
        '.wallet-cart-button-container:has(shopify-apple-pay-button)',
        '.wallet-cart-button-container:has([data-brand="applePay"])',
        '.wallet-cart-button-container:has(slot[name="button-ApplePay"])'
      );
    }

    if (!selectors.length) {
      return '';
    }

    return selectors.join(',\n') + ' { display:none !important; }';
  }

  function getWalletTargetSelector() {
    var selectors = [];

    if (targets.collapseGooglePay) {
      selectors.push(
        'shopify-google-pay-button',
        '[data-brand="googlePay"]',
        'slot[name="button-GooglePay"]'
      );
    }

    if (targets.collapseApplePay) {
      selectors.push(
        'shopify-apple-pay-button',
        '[data-brand="applePay"]',
        'slot[name="button-ApplePay"]'
      );
    }

    return selectors.join(',');
  }

  function collapseWalletSlots(host) {
    var targetSelector = getWalletTargetSelector();

    if (!targetSelector) {
      return;
    }

    var root = host && host.shadowRoot;
    if (!root) {
      return;
    }

    try {
      var containers = root.querySelectorAll(
        '.wallet-cart-grid > *, ' +
          '.accelerated-checkout-button-container > *, ' +
          '.wallet-cart-button-container'
      );

      for (var i = 0; i < containers.length; i++) {
        var container = containers[i];

        if (container.matches(targetSelector) || container.querySelector(targetSelector)) {
          container.style.setProperty('display', 'none', 'important');
        }
      }

      var targetsToHide = root.querySelectorAll(targetSelector);
      for (var j = 0; j < targetsToHide.length; j++) {
        targetsToHide[j].style.setProperty('display', 'none', 'important');
      }

    } catch (e) {
      /* no-op */
    }
  }

    /**
   * @param {Element} host
   */
    function injectSlotFix(host) {
      if (!slotFixCss) {
        return;
      }
  
      if (!host || host.localName !== CART_HOST) {
        return;
      }
  
      var root = host.shadowRoot;
      if (!root) {
        return;
      }
  
      if (!host[HOST_FLAG]) {
        try {
          var style = document.createElement('style');
          style.setAttribute(STYLE_ATTR, '');
          style.textContent = slotFixCss;
          root.appendChild(style);
          host[HOST_FLAG] = true;
        } catch (e) {
          /* no-op */
        }
      }
  
      collapseWalletSlots(host);
    }
  
    function scanCartCheckoutHosts() {
      var nodes = document.getElementsByTagName(CART_HOST);
  
      for (var i = 0; i < nodes.length; i++) {
        injectSlotFix(nodes[i]);
      }
    }
  
    function startObserver() {
      scanCartCheckoutHosts();
  
      try {
        new MutationObserver(scanCartCheckoutHosts).observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      } catch (e) {
        /* no-op */
      }
    }
  
    startObserver();
  })();
